module.exports = __webpack_public_path__ + "static/media/what-pkt-mobile.7b4965ad.png";